document.addEventListener('DOMContentLoaded', () => {
    // Check if there is any heading containing 'get in touch'
    const headings = document.querySelectorAll('.custom-heading');
    let targetHeading = null;
    let targetForm = null;

    for (let heading of headings) {
        if (heading.textContent.toLowerCase().includes('get in touch')) {
            targetHeading = heading;
            // Find the closest form state or form
            targetForm = heading.closest('.shopify-section').querySelector('form[action*="/contact"]');
            break;
        }
    }

    if (!targetHeading || !targetForm) return;

    // We need to load lottie-web if not already present
    function loadLottieAndInit() {
        if (typeof lottie === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js';
            script.onload = initMarkerAnimation;
            document.head.appendChild(script);
        } else {
            initMarkerAnimation();
        }
    }

    function initMarkerAnimation() {
        // Prepare the heading for absolute positioning of the lottie container
        targetHeading.style.position = 'relative';
        targetHeading.style.display = 'inline-block';
        targetHeading.style.zIndex = '1';

        // Ensure inner text has a higher z-index if wrapped
        const originalHTML = targetHeading.innerHTML;
        targetHeading.innerHTML = `<span style="position: relative; z-index: 2;">${originalHTML}</span>`;

        // Create Lottie container
        const lottieContainer = document.createElement('div');
        lottieContainer.style.position = 'absolute';
        lottieContainer.style.left = '50%';
        lottieContainer.style.bottom = '-10px'; // Adjust based on animation visually acting as an underline
        lottieContainer.style.transform = 'translateX(-50%)';
        lottieContainer.style.width = '120%';
        lottieContainer.style.height = '60px';
        lottieContainer.style.pointerEvents = 'none';
        lottieContainer.style.zIndex = '1';
        
        targetHeading.appendChild(lottieContainer);

        const markerUrl = window.Shopify ? window.Shopify.cdnHost || '' : '';
        // Find the marker URL injected in theme.liquid or construct it manually
        // Since we are in an asset, we can't reliably use asset_url here directly.
        // We'll try to find a global script tag or use a known URL format.
        
        // Let's grab the URL from the currently executing script if we can, or just expect it globally
        const markerPath = document.querySelector('script[data-marker-url]')?.getAttribute('data-marker-url') || '/cdn/shop/t/1/assets/marker.json'; 
        // We will make sure to inject data-marker-url in theme.liquid!

        const anim = lottie.loadAnimation({
            container: lottieContainer,
            renderer: 'svg',
            loop: false,
            autoplay: true, // Always active on load
            path: document.querySelector('#bonj-marker-data')?.getAttribute('data-url')
        });

        // Speed up the animation slightly for snappier feel
        anim.setSpeed(1.5);

        const inputs = targetForm.querySelectorAll('input, textarea, select');
        
        // Replay the animation when any input field becomes active
        inputs.forEach(input => {
            input.addEventListener('focus', () => {
                anim.setDirection(1);
                anim.goToAndPlay(0, true);
            });
        });
    }

    loadLottieAndInit();
});
